import PopExplanation from './PopExplanation';
import PropTypes from 'prop-types';

export default function PopAccessibility({ page = false, size }) {

    return (
        <PopExplanation 
            title="Accessibility" 
            size={size}
            metric1Title={page ? "" : "Total Rules Checked"}
            metric1Desc={page ? "Makes sure our app can be used by everyone, including those with disabilities. Follows design standards for an easy-to-use interface for all." : "Shows the total number of accessibility rules checked across all pages, indicating the scope of the accessibility assessment."}
            metric2Title={page ? "" : "Pass Rate"}
            metric2Desc={page ? "" : "Shows the percentage of accessibility rules that did not trigger violations across all pages. Calculated as total rules checked minus accessibility violations, providing insight into overall compliance with accessibility standards."} />
    );
}

PopAccessibility.propTypes = {
    page: PropTypes.bool,
    size: PropTypes.number
}